import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaM365AcquisitionsDatabase" */ './lazyIndex'),
    { name: 'OwaM365AcquisitionsDatabase' }
);

export const lazyUpdateDatabaseCachedAcquisitions: LazyAction<
    typeof lazyIndex.updateDatabaseCachedAcquisitions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateDatabaseCachedAcquisitions);

export const lazyWriteToAcquisitionsCacheFromIndexedDb: LazyAction<
    typeof lazyIndex.writeToAcquisitionsCacheFromIndexedDb,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.writeToAcquisitionsCacheFromIndexedDb);
